/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { KTSVG } from '../../../helpers'

type Props = {
  className?: string
  functionSubmit?: any
  options?: string[]
  selectedOption: string
}

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}

const DropdownFilterCompetitor: FC<Props> = ({ 
  className = '', 
  functionSubmit, 
  options = [], 
  selectedOption = 'All Competitors' }) => {
  return (
    <div className= {className}>
      <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' }}>{selectedOption}</div>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 scroll-y mh-250px px-2' data-kt-menu='true'>
        {options.map((data, index) => (
        <div className='menu-item px-3'key={data}>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(data, 'competitor'); changeDropDownText(e); }} >
            {data}
          </a>
        </div>
        ))}
      </div>
      {/* end::Menu */}
    </div>
  )
}

export { DropdownFilterCompetitor }
